var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99967 10.8C6.82147 10.8 5.86634 9.84487 5.86634 8.66667C5.86634 7.48846 6.82147 6.53333 7.99967 6.53333C9.17788 6.53333 10.133 7.48846 10.133 8.66667C10.133 9.84487 9.17788 10.8 7.99967 10.8ZM13.333 3.33333C14.0663 3.33333 14.6663 3.93333 14.6663 4.66667V12.6667C14.6663 13.4 14.0663 14 13.333 14H2.66634C1.93301 14 1.33301 13.4 1.33301 12.6667V4.66667C1.33301 3.93333 1.93301 3.33333 2.66634 3.33333H4.77967L5.59967 2.43333C5.85301 2.16 6.21301 2 6.58634 2H9.41301C9.78634 2 10.1463 2.16 10.393 2.43333L11.2197 3.33333H13.333ZM7.99967 12C9.83967 12 11.333 10.5067 11.333 8.66667C11.333 6.82667 9.83967 5.33333 7.99967 5.33333C6.15967 5.33333 4.66634 6.82667 4.66634 8.66667C4.66634 10.5067 6.15967 12 7.99967 12Z",
    fill: "#858EBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.a36e64deb69134935e972d543ef17a30.svg";
export { ForwardRef as ReactComponent };